import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import style from './InfoBar.module.sass'

type InfoBarProps = {
	type: 'positiveGreen' | 'negativeRed' | 'infoYellow' | 'warningRed'
	label: string
}

export const InfoBar: FunctionComponent<InfoBarProps> = ({ type, label }) => {
	return (
		<div
			className={clsx(
				style.bar,
				type === 'positiveGreen' && style.barPositive,
				type === 'negativeRed' && style.barNegative,
				type === 'infoYellow' && style.barInfo,
				type === 'warningRed' && style.barNegative,
			)}
		>
			{type === 'warningRed' && <span className={clsx(style.icon, style.iconInfo, style.iconInfoRed)}>i</span>}
			{type === 'positiveGreen' && <span className={style.icon}>+</span>}
			{type === 'negativeRed' && <span className={style.icon}>-</span>}
			{type === 'infoYellow' && <span className={clsx(style.icon, style.iconInfo)}>i</span>}

			<span>{label}</span>
		</div>
	)
}
